import { Collection } from 'modules/core/lib/mobx-rest'

import { Provider } from 'modules/ats/lib/enums'
import Promotion from 'modules/ats/store/models/Promotion'

class Promotions extends Collection<Promotion> {
  get cacheKey(): string {
    return 'promotions'
  }

  get indexes() {
    return ['provider']
  }

  missing_fields(ats_job_posting_id: number, provider: Provider) {
    return this.rpc('missing_fields', {
      ats_job_posting_id: ats_job_posting_id,
      provider: provider,
    })
  }

  model() {
    return Promotion
  }
}

export { Promotions }
